import brand from '../views/brand/index.vue'
import brand_create from '../views/brand/create.vue'
import brand_edit from '../views/brand/edit.vue'
import brand_detail from '../views/brand/detail.vue'
import brand_import from '../views/brand/import.vue'

const routes = [
  {
    path: "/brand",
    name: "brand",
    component: brand,
    meta: { authOnly: true },
  },
  {
    path: "/brand/create",
    name: "brand_create",
    component: brand_create,
    meta: { authOnly: true },
  },
  {
    path: "/brand/edit/:uuid",
    name: "brand_edit",
    component: brand_edit,
    meta: { authOnly: true },
  },
  {
    path: "/brand/detail/:uuid",
    name: "brand_detail",
    component: brand_detail,
    meta: { authOnly: true },
  },
  {
    path: "/brand/import",
    name: "brand_import",
    component: brand_import,
    meta: { authOnly: true },
  },]

export default routes
